import {Component} from 'react'
import {connect} from 'react-redux'
import {toastr} from 'react-redux-toastr'

import SkillsForm from '../../../../components/Forms/SkillsForm/SkillsForm.jsx'
import api from '../../../../../api.js'
import {setCurrentFreelance, setCurrentUser} from '../../../../components/CurrentUserLoader/actions.js'

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService'
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService'

import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx"

class Skills extends Component {
  state = {enrichingMasterSkills: false, freshFreelance: null}

  onUploadSuccess = (image) => {
    this.props.refresh({
      user: {
        ...this.props.user,
        image,
      },
      freelance: {
        ...this.props.freelance,
        image,
      },
    })
  }

  submit = (values) => {
    this.props.submit({
      user: prepareUserBeforeSubmit(values.user),
      freelance: this.prepareFreelance(values.freelance)
    })
  }

  prepareFreelance = (freelance) => {
    return {
      ...prepareFreelanceBeforeSubmit(freelance),
    }
  }

  expandSecteurs = (freelance) => {
    const selectedSecteursIds = freelance.secteurs.map(secteur => secteur.id)

    return this.props.secteurs.reduce((acc, secteur) => {
      secteur.checked = selectedSecteursIds.includes(secteur.id)
      acc.push(secteur)
      return acc
    }, [])
  }

  enrichMasterSkills = async () => {
    const {freelance} = this.props
    this.setState({enrichingMasterSkills: true})
    try {
      const response = await api.freelances.aiMasterSkills({freelance: freelance.id})
      if (response.data.success) {
        const [freshFreelance, freshUser] = await Promise.all([
          api.freelances.getOne({freelance: freelance.id}),
          api.users.getMe(),
        ])
        this.props.setCurrentFreelance(freshFreelance.data)
        this.props.setCurrentUser(freshUser.data)
        this.setState({freshFreelance: freshFreelance.data})
        toastr.success('Spécialités enrichies avec succès.')
      } else {
        toastr.error(response.data.error)
      }
    } catch (e) {
      toastr.error("Une erreur est survenue lors de l'enrichissement des spécialités.")
    } finally {
      this.setState({enrichingMasterSkills: false})
    }
  }

  render() {
    const {enrichingMasterSkills, freshFreelance} = this.state
    const currentFreelance = freshFreelance || this.props.freelance

    return (
      <FreelancePage className="p-5">
        <div className="step-general-pres">
          {this.props.user && currentFreelance &&
          <div>
            <SkillsForm
              isAdmin={this.props.isAdmin}
              enableReinitialize={true}
              onSubmit={this.submit}
              initialValues={{
                user: this.props.user,
                freelance: {...currentFreelance}
              }}
              onSubmitSuccess={this.props.onFormSuccess}
              enrichMasterSkills={this.enrichMasterSkills}
              enrichingMasterSkills={enrichingMasterSkills}
            />
          </div>
          }
        </div>
      </FreelancePage>
    )
  }
}

export default connect(
  state => ({
    secteurs: state.secteurs.secteurs
  }),
  dispatch => ({
    setCurrentFreelance: (freelance) => dispatch(setCurrentFreelance(freelance)),
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  })
)(Skills)
